import { addStyles } from 'ethcss'
import { colors, IStyles } from '../../../theme'

const selectFromFileStyles: IStyles = {
    selectorWrapper: {
        display: 'flex',
        alignItems: 'center',
        marginTop: 24,
        paddingLeft: 10,
    },
    selectorText: {
        marginLeft: 8,
        cursor: 'pointer',

        '&:hover': {
            color: colors.blueAccent,
        },
    },
    inProgress: {
        height: 16.5,
    },
}

addStyles(selectFromFileStyles)
export default selectFromFileStyles
